import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { Address } from "../../../common/types";
import FormattedAddress from "../FormattedAddress";
import PaymentDetailsModalField from "../PaymentDetailsModalField";
import { getAddress } from "../utils";
import { type CheckPaymentPrefDisplayProps } from "./types";

export const CheckPaymentPrefDisplay: React.FC<CheckPaymentPrefDisplayProps> = ({
  checkPaymentPrefFull,
  checkAddressOverride,
}: CheckPaymentPrefDisplayProps) => {
  let checkAddress: Address | undefined = checkAddressOverride;
  if (checkPaymentPrefFull?.address && !checkAddressOverride) {
    checkAddress = getAddress(checkPaymentPrefFull.address);
  }

  const invalidCheckAddress = checkPaymentPrefFull.useAccountMailingAddress && !checkAddress;

  const gap = 8; // gap between rows and columns
  return (
    <Flex gap={gap} flexDirection="column" data-testid="CheckPaymentPrefDisplayFlex">
      <PaymentDetailsModalField
        label="Recipient name"
        value={checkPaymentPrefFull.payeeName}
        gap={gap}
      />
      {checkPaymentPrefFull.memo && (
        <PaymentDetailsModalField label="Memo" value={checkPaymentPrefFull.memo} gap={gap} />
      )}
      <Flex gap={gap}>
        <Flex flexBasis="60%">
          <Text variant="secondary-md">Address</Text>
        </Flex>
        <Flex flexBasis="100%" flexDirection="column">
          {invalidCheckAddress && <Text>Related account has no mailing address.</Text>}
          {checkAddress && <FormattedAddress address={checkAddress} variant="regular-md" />}
        </Flex>
      </Flex>
    </Flex>
  );
};
